import React from 'react';
import {
  Document,
  Page,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  }
});

export default function DocumentFormPdfDocument({
  images,
}) {
  const pages = Array.isArray(images) ? images.filter(Boolean) : [];

  return (
    <Document>
      {pages.map((src, idx) => (
        <Page
          key={`pdf-page-${idx}`}
          size="A4"
          style={styles.page}
          wrap={false}
        >
          <Image src={src} style={styles.image} wrap={false} />
        </Page>
      ))}
    </Document>
  );
}

